import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomTransferAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomTransferAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomTransferAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.tra"
        className="room-form__transfer-air"
        label={t("Room.tra")}
        unit="m³/h"
        color="#b3b3b3"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__transfer-air__input"
      />
    )
  }
)
